import { Constants } from "../../model/Constants";
import { log } from "../../chatframe/Utils";

declare const Janus :any;

export default class JanusMessageHandler {
    callMgr: any;

    feeds: any[];

    myid: any;

    constructor(callMgr: any) {
        this.callMgr = callMgr;
        this.feeds = [];
        this.myid = null;
    }

    /**
     * Utility function to handle Event message from Janus Application server
     * @param event
     * @param msg
     * @param statusCb
     */
    handleServerMessage(event: any, msg: any, statusCb: any): void {
        if (event) {
            if (event === Constants.ROOM_JOINED) {
                /**
                 * Publisher/manager created, negotiate WebRTC and
                 * attach to existing feeds, if any
                 */
                this.whenRoomJoined(msg, event, statusCb);
            } else if (event === "destroyed") {
                // The room has been destroyed
            } else if (event === "event") {
                // Any new feed to attach to?
                if (msg["publishers"]) {
                    this.whenPublisherJoined(msg, statusCb);
                } else if (msg["leaving"]) {
                    // One of the publishers has gone away?
                    this.whenPublisherLeaving(msg, statusCb);
                } else if (msg["unpublished"]) {
                    // One of the publishers has unpublished?
                    this.whenSomeOneUnpublished(msg, statusCb);
                } else if (msg[Constants.RTC_ERROR]) {
                    statusCb(Constants.RTC_ERROR);
                }
            }
        }
    }

    /**
     * Handle when the customer joined the room
     * @param msg
     * @param event
     * @param statusCb
     */
    whenRoomJoined(msg: any, event: any, statusCb: any): void {
        this.myid = msg["id"];
        this.callMgr.mypvtid = msg["private_id"];

        /*
         * Janus.log(`Successfully joined room ${msg["room"]}
         *  with ID ${this.callMgr.myid}`);
         */
        this.callMgr.publishOwnFeed(true, statusCb);

        // Any new feed to attach to?
        if (msg["publishers"]) {
            this.whenPublisherJoined(msg, statusCb);
        }

        statusCb(event);
    }

    /**
     * When a new publisher is joined
     * @param msg
     * @param statusCb
     */
    whenPublisherJoined(msg: any, statusCb: any): void {
        const publishersList = msg["publishers"];
        Janus.debug("Got a list of available "
            + "publishers/feeds:", publishersList);

        for (const publisher in publishersList) {
            const id = publishersList[publisher]["id"];
            const display = publishersList[publisher]["display"];
            const audio = publishersList[publisher]["audio_codec"];
            const video = publishersList[publisher]["video_codec"];
            Janus.debug(`  >> [${id}] ${display} (audio: ${audio}, video: ${video})`);
            this.callMgr.newRemoteFeed(id, display, audio, video,
                statusCb);
        }
    }

    /**
     * Handle when one of the publisher is leaving, could be a network failure for them
     * @param msg
     * @param statusCb
     */
    whenPublisherLeaving(msg: any, statusCb: any): void {
        const leaving = msg["leaving"];
        Janus.log(`Publisher left: ${leaving}`);
        let remoteFeed = null;

        for (let i = 0; i < this.feeds.length; i++) {
            if (this.feeds[i]
                && this.feeds[i].rfid === leaving
            ) {
                remoteFeed = this.feeds[i];
                break;
            }
        }

        if (remoteFeed !== null) {
            Janus.debug(`Feed ${remoteFeed.rfid} 
            (${remoteFeed.rfdisplay}) has left the room, detaching`);
            log(`Feed leaving: ${remoteFeed.rfid}`);
            this.feeds[remoteFeed.rfindex - 1] = null;
            remoteFeed.detach();

            if (this.isAllAgentsLeft()) {
                statusCb(Constants.RTC_ERROR);
            }
        }
    }

    /**
     * Handle when one of the publisher has unpublished
     * @param msg
     * @param statusCb
     */
    whenSomeOneUnpublished(msg: any, statusCb: any): void {
        const unpublished = msg["unpublished"];
        Janus.log(`Publisher left: ${unpublished}`);

        if (unpublished === "ok") {
            // That's us
            this.callMgr.sfutest.hangup();
            return;
        }

        let remoteFeed = null;

        for (let i = 0; i < this.feeds.length; i++) {
            if (this.feeds[i]
                && this.feeds[i].rfid == unpublished
            ) {
                remoteFeed = this.feeds[i];
                break;
            }
        }

        if (remoteFeed != null) {
            Janus.debug(`Feed ${remoteFeed.rfid} 
            (${remoteFeed.rfdisplay}) has left the room, detaching`);
            log(`Feed leaving: ${remoteFeed.rfid}`);

            this.feeds[remoteFeed.rfindex - 1] = null;
            remoteFeed.detach();

            if (this.isAllAgentsLeft()) {
                statusCb(Constants.AGENT_VIDEO_ERROR);
            }
        }
    }

    handleServerMessageForRemoteFeed(msg: any, event: any, remoteFeed: any, statusCb: any): void {
        if (msg[Constants.RTC_ERROR]) {
            statusCb(Constants.RTC_ERROR);
        } else if (event) {
            if (event === "attached") {
                // Subscriber created and attached

                this.feeds.push(remoteFeed);
                remoteFeed.rfindex = this.feeds.length;

                remoteFeed.rfid = msg["id"];
                remoteFeed.rfdisplay = msg["display"];
                Janus.log(`Successfully attached to feed ${remoteFeed.rfid} 
                        (${remoteFeed.rfdisplay}) in room ${msg["room"]}`);
            } else if (event === "event") {
                // Check if we got an event on a simulcast-related event from this publisher
            } else {
                // What has just happened?
            }
        }
    }

    isAllAgentsLeft(): boolean {
        let truthyLength = 0;
        this.feeds.forEach(value => {
            if (value && value.rfindex) {
                truthyLength += 1;
            }
        });

        if (truthyLength === 0) {
            return true;
        }
        return false;
    }
}
